var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"borrwingClass"},[_c('span',{staticClass:"sampleTypeClass"},[_vm._v("样品返还流程")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.contentObj.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }